<template>
  <div v-if="true" class="linear-loading-container">
    <div
      :style="`width: ${size}px; height: ${size}px; background: ${color};`"
      class="loading-ball ball-1"
    ></div>
    <div
      :style="`width: ${size}px; height: ${size}px; background: ${color};`"
      class="loading-ball ball-2"
    ></div>
    <div
      :style="`width: ${size}px; height: ${size}px; background: ${color};`"
      class="loading-ball ball-3"
    ></div>
  </div>
</template>

<script>
export default {
  name: "LinearLoading",
  props: {
    size: String | Number,
    color: String | Number
  }
};
</script>

<style lang="scss" scoped>
@keyframes loadingPulse {
  0% {
    scale: 1;
  }
  40% {
    scale: 1.3;
  }
  80% {
    scale: 1;
  }
}
.loading-ball {
  height: 5px;
  width: 5px;
  background: var(--preto);
  border-radius: 2px;
  margin: 1px;
  z-index: 10;
}
.linear-loading-container {
  display: flex;
}
.ball-1 {
  scale: 1;
  animation: loadingPulse 1.2s infinite ease-in-out;
}
.ball-2 {
  scale: 1;
  animation: loadingPulse 1.2s 0.2s infinite ease-in-out;
}
.ball-3 {
  scale: 1;
  animation: loadingPulse 1.2s 0.4s infinite ease-in-out;
}
</style>
